import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import { App as AntdApp } from 'antd'
import zhCN from 'antd/locale/zh_CN'
import 'antd/dist/reset.css'
import './styles/globals.css'
import App from './App'
import { store } from './store'
import ThemeConfigWrapper from './components/ThemeConfigWrapper'

const baseTheme = {
  token: {
    colorPrimary: '#3b82f6',
    borderRadius: 8,
  },
  components: {
    Card: { paddingLG: 24 },
    Table: { paddingContentVerticalLG: 16 },
  },
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  // <React.StrictMode>
    <Provider store={store}>
      <ThemeConfigWrapper locale={zhCN} baseTheme={baseTheme}>
        <AntdApp>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </AntdApp>
      </ThemeConfigWrapper>
    </Provider>
  // </React.StrictMode>,
)